<script setup>
import xModal from '@/components/common/xModal.vue'
import xCheckbox from '@/components/common/xCheckbox.vue'
import { ref } from 'vue'
import { airDropCheckShow, airDropCloseShow } from '~/apis/airdrop'
import isMobile from 'is-mobile'

const props = defineProps({
  showRemind: {
    type: Boolean,
    default: false,
  },
})

const show = defineModel(false)

const dontRemind = ref(false)
const toggleModalVisibility = () => (show.value = !show.value)

onMounted(async () => {
  if (props.showRemind) {
    const res = await airDropCheckShow()
    if (res.success) {
      show.value = res.data.show
    }
  }
})

async function comfirmClose() {
  toggleModalVisibility()
  if (dontRemind.value) {
    await airDropCloseShow()
  }
}

function downLoadApp() {
  toggleModalVisibility()
  window.location.href = 'https://download-wallet.tantin.com/'
}
</script>

<template>
  <xModal
    v-model:show="show"
    :width="isMobile() ? '90%' : '400px'"
    :cancel-text="$t('知道了')"
    :ok-text="$t('立即下载')"
    :ok="downLoadApp"
    :cancel="comfirmClose"
    @close="toggleModalVisibility"
  >
    <div class="px-6 text-center max-md:px-4">
      <img src="@/assets/images/airdrop/wallet.jpg" alt="Tantin Wallet" class="w-[180px] h-[180px]  mx-auto mb-4">
      <i18n-t
        keypath="推荐下载 {0} 管理 CTC资产，Tantin Wallet是作为Tantin Chain官方指定唯一钱包。" scope="global" tag="label"
        class="text-justify text-sm font-medium text-textPrimary mb-6"
      >
        <span class="font-bold text-textPrimary">{{ $t('Tantin Wallet') }}</span>
      </i18n-t>

      <!-- 不再提醒选项 -->
      <div v-if="showRemind" class="mt-4">
        <xCheckbox v-model="dontRemind" class="py-4 text-textPrimary">
          {{ $t('不再提醒') }}
        </xCheckbox>
      </div>
    </div>
  </xModal>
</template>
